<template>
    <el-dialog
        :title="mode == 'add' ? '新增模板' : '编辑模板'"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="700px">
        <el-form :model="form" :rules="rules" ref="form" label-width="80px" class="demo-ruleForm">
            <el-form-item label="模板名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入模板名称" size="medium"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
                <el-input-number v-model="form.sort" :min="1" :max="100"></el-input-number>
            </el-form-item>
            <el-form-item label="上传模板" prop="fileId" class="upload-form-items">
                <el-upload
                    class="upload-demo"
                    drag
                    action="none"
                    accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG"
                    :multiple="false"
                    :show-file-list="false"
                    :auto-upload="false"
                    :on-change="handleUploadFile">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
                <div v-if="form.fileId">
                    <img :src="form.fileId | uploadFileUrl()" alt="" >
                </div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" size="medium" @click="save">保存</el-button>
            <el-button size="medium" @click="closeDialog">取 消</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { toolUploadAPI } from 'liankong-ui-api'
import SparkMD5 from "spark-md5";
export default {
    props:{
        vkey: {
            type: String
        }
    },
    data() {
        return {
            dialogVisible: false,
            mode: 'add',
            loading:null,
            form: {
                name: '',
                sort: 1,
                image: null,
            },
            rules: {
                name: [
                    { required: true, message: '请输入模板名称', trigger: 'change' }
                ],
                sort: [
                    { required: true, message: '请输入排序序号', trigger: 'change' }
                ],
                image: [
                    { required: true, message: '请上传模板图片', trigger: 'change' }
                ]
            },
        };
    },
    methods: {
        show(type, row) {
            this.dialogVisible = true;
            this.mode = type;
            if(type == 'add') {
                this.form = {
                    name: '',
                    sq: 1,
                    fileId: null
                }
            } else {
                console.log(row)
                this.form = {
                    id:row.id,
                    name: row.name,
                    sort: row.sort,
                    fileId: row.fileId
                }
            }

            this.$refs['form'] ? this.$refs['form'].resetFields() : '';
        },
    
        // 上传
        handleUploadFile(file, fileList) {
            // 获取中文件后缀
            const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
            const fileFormat = ['png', 'jpg', 'jpe', 'jpeg', 'jif', 'jfif', 'jfi', 'PNG', 'JPG', 'JPEG', 'JPE', 'svg'];
            if (fileFormat.indexOf(fileSuffix) === -1) {
                this.$message.error('上传文件只能是png、jpg、jpe、jpeg、jif、jfif、jfi、PNG、JPG、JPEG、JPE、svg格式');
                return false;
            }

            this.loading = this.$loading({
				lock: true,
				text: '文件上传中,请稍后......',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});


            this.checkFileMD5(file)
        },
        
		// 检查md5
		checkFileMD5 (file){
			let fileReader = new FileReader();
			let time = new Date().getTime();
			let blobSlice =
				File.prototype.slice ||
				File.prototype.mozSlice ||
				File.prototype.webkitSlice;
			let currentChunk = 0;
			const chunkSize = 1024 * 1024;
			let chunks = Math.ceil(file.size / chunkSize);
			let _this = this;
			let spark = new SparkMD5.ArrayBuffer();
			loadNext();
			fileReader.onload = (e) => {
				spark.append(e.target.result);
				if (currentChunk < chunks) {
					currentChunk++;
					loadNext();
				} else {
					let md5 = spark.end();
					spark.destroy(); //释放缓存
					file.md5 = md5; //将文件md5赋值给文件唯一标识
					const fileTask = {
						filename:file.name,
						identifier:md5,
						totalSize:file.size,
						chunkNumber:currentChunk,
						currentChunkSize:chunkSize,
						totalChunks:chunks,
                        docType:6
					}
					toolUploadAPI.fileChunkUploadGet(fileTask).then(res => {
						let skip = false;
						if(res.data.skipUpload){
							skip = true;
                            _this.emitCallbackData([res.data.info]);
						}else if(!res.data.skipUpload && res.data.uploaded && res.data.uploaded.length == chunks){
							_this.fileMerge(res,skip,file)
						}else{
							new Promise((resolve, reject) => {
								let num = 0;
								if( res.data.uploaded){
									num = num + res.data.uploaded.length;
								}
								let arr = []
								for(let i = 1; i<=chunks;i++){
									if(res.data.uploaded && res.data.uploaded.indexOf(i) !== -1){
										// console.log('已经上传的分片，不再进行上传')
									}else{
									arr.push(i) 
									}
								}
								arr.map(index =>{
                                    let start = (index-1) * chunkSize;
                                    let chunk = file.raw.slice(start, Math.min(file.size, start + chunkSize));
                                    console.log('每个分片的信息',chunk,index)
									let formData = new FormData();
									formData.append('filename', file.name );
									formData.append('identifier', md5);
									formData.append('totalSize', file.size);
									formData.append('chunkNumber', index);
									formData.append('currentChunkSize', chunkSize);
									formData.append('chunkSize', chunkSize);
									formData.append('totalChunks', chunks);
									formData.append('file', chunk);
									formData.append('docType', 6);
									toolUploadAPI.fileChunkUploadPost(formData).then(res => {
										num += 1;
										if(num == chunks){
											resolve({
												result:res
											})
										}
									}) 
								})
							
							}).then(res =>{
								_this.fileMerge(res.result,skip,file)
							})    
						}
					})
					
				}
			};


			fileReader.onerror = function () {
				_this.$message.error(`文件${file.name}读取出错，请检查该文件`);
			};
			function loadNext() {
				let start = currentChunk * chunkSize;
				let end =
				start + chunkSize >= file.size ? file.size : start + chunkSize;
				fileReader.readAsArrayBuffer(blobSlice.call(file.raw, start, end));
			}
		
		},

        fileMerge (res,skip,file) {
			if(res.success && !skip){
				toolUploadAPI.fileChunkUploadMerge({
					fileName:file.name,
					signKey:file.md5,
                    docType:6
				}).then(res => {
					if(res.code == 0){
                        this.emitCallbackData([res.data]);
					}else{
						this.$message.error(res.message)
					}
				})
			}else{
				emitCallbackData([res.data.info]);
			
			}
		},
        // 传递数据
		emitCallbackData(list){
			this.loading.close()
            this.form.fileId = list[0].documentId;
			this.$message.success('上传成功')
		},
        // 保存
        save() {
            this.$refs['form'].validate((valid) => {
                if (valid) {

                    this.$store.dispatch(`manage/${this.mode == 'add' ? 'add' : 'edit'}`, {
                        vkey: this.vkey,
                        query: this.form,
                        requestInterfaceName: this.mode == 'add' ? 'addTemplate' : 'editTemplate',
                        listInterfaceName: 'getTemplateList'
                    }).then(res=>{
                        if(res.code == 0) {
                            this.$message.success(this.mode == 'add' ? '添加成功' : '修改成功');
                        }
                        this.closeDialog();
                    })
                }
            });
        },
        closeDialog() {
            this.dialogVisible = false;
            this.$refs['form'].resetFields();
        }
    }
};
</script>
<style lang="less" scoped>
.demo-ruleForm {
    /deep/ .upload-form-items {
       .el-form-item__content {
            display: flex;
            img {
                width: 200px;
                height: 120px;
                margin-left: 20px;
                border-radius: 3px;
            }
       }
    }
    /deep/ .el-upload {
        .el-upload-dragger {
            width: 280px;
            height: 150px;
            .el-icon-upload {
                margin: 25px 0 0;
            }
        }
    }
}
</style>